import {
    Component,
    computed,
    effect,
    inject,
    input,
    inputBinding,
    output,
    outputBinding,
    viewChild,
    ViewContainerRef
} from '@angular/core';
import type { TileConfig, TileData } from '../../../interfaces/Tile.interface';
import { TilesStaticProvider } from '../../../providers/tiles/tiles.static.provider';
import type { SpawnableTile } from '../spawnable-tile/spawnable-tile.component';

@Component({
    styleUrls: ['./tile-spawner.scss'],
    selector: 'tile-spawner',
    templateUrl: 'tile-spawner.html'
})
export class TileSpawnerComponent {
    private _tilesStaticProvider = inject(TilesStaticProvider);

    private _container = viewChild.required('spawn', { read: ViewContainerRef });

    tileData = input.required<TileData>();
    tileConfig = input<TileConfig>({});

    deleted = output<void>();
    edited = output<TileData>();

    private _tileComponent = computed(() => this._tilesStaticProvider.getTileProvider(this.tileData().tileType)?.getTileComponent());

    constructor() {
        effect(onCleanup => {
            const tileComponent = this._tileComponent();
            if (!tileComponent) return;

            const tileRef = this._container().createComponent<SpawnableTile<TileData>>(tileComponent, {
                bindings: [
                    inputBinding('tileData', this.tileData),
                    inputBinding('tileConfig', this.tileConfig),
                    outputBinding('deleted', () => this.deleted.emit()),
                    outputBinding<TileData>('edited', newTileData => this.edited.emit(newTileData))
                ]
            });

            onCleanup(() => tileRef.destroy());
        });
    }
}
